import Ractive from 'ractive';

import template from './views/counter-label.html';

let CounterLabel = Ractive.extend({
	template
});

export default CounterLabel;


// WEBPACK FOOTER //
// ./src/ractive/components/CounterLabel.js